import React from "react";

const GlobalContext = React.createContext({ lang: "ENG", setLang: () => {} });

export default GlobalContext;
